import React from "react";
import WhatHappensNextNegative from "../../components/activations/WhatHappensNextNegative";
import ReturnToHomepage from "../../components/activations/ReturnToHomepage";
import CongratsOnJoining from "../../components/activations/CongratsOnJoining";

export default function FindOwnProvider() {
  return (
    <>
      <CongratsOnJoining />
      <p className="mt-4">
        We understand you would like to find your own provider.
      </p>
      <p>
        <strong>More frequent checks</strong> may be necessary if you have
        pre-existing diabetes related eye diseases like diabetic retinopathy or
        if your eye care provider considers you to be at a higher risk of eye
        disease.
      </p>
      <p>
        Regular eye checks help protect your vision and it's recommended people
        with diabetes get eye checks every two years.
      </p>
      <hr className="my-6" />
      <WhatHappensNextNegative />
      <ReturnToHomepage />
    </>
  );
}
